import SeoHead from '../components/SeoHead'
import SubscriptionCanceledView from '../views/SubscriptionCanceled'
import { useLanguage } from '../i18n/LanguageContext'

const SubscriptionCanceledPage = () => {
  const { t } = useLanguage()

  return (
    <>
      <SeoHead
        title={t('seo.subscriptionCanceledTitle')}
        description={t('seo.subscriptionCanceledDescription')}
        path="/subscription-canceled"
        noIndex
      />
      <SubscriptionCanceledView />
    </>
  )
}

export default SubscriptionCanceledPage
